import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { Button } from '@s4l/ds'
import RequestModal from '../RequestModal'

import { displayAlertAction } from 'src/comps/AlertMessage/actions'

interface RequestButtonProps {
  hash: string
  onSubmit: () => void
}

const RequestButton: React.FC<RequestButtonProps> = ({ hash, onSubmit }) => {
  const intl = useIntl()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const dispatch = useDispatch()

  const handleClick = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleFormSubmit = () => {
    setIsModalOpen(false)
    dispatch(
      displayAlertAction({
        title: intl.formatMessage({
          id: 'notification-success.invoice-title',
        }),
        description: intl.formatMessage({
          id: 'notification-success.invoice-body',
        }),
        severity: 'success',
      })
    )
    onSubmit()
  }

  const handleFormError = () => {
    dispatch(
      displayAlertAction({
        title: intl.formatMessage({
          id: 'notification-error.invoice-title',
        }),
        description: intl.formatMessage({
          id: 'notification-error.invoice-body',
        }),
        severity: 'error',
      })
    )
  }

  return (
    <>
      <Button fullWidth variant="outlined" onClick={handleClick}>
        {intl.formatMessage({
          id: 'global.request-invoice',
        })}
      </Button>
      <RequestModal
        hash={hash}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onError={handleFormError}
        onSubmit={handleFormSubmit}
      />
    </>
  )
}

export default RequestButton
